module.exports = __webpack_public_path__ + "comic.ae838b85.png";